<template>
  <div class="authentication">
    <div class="page-title">{{ lang.pageTitle }}</div>
    <form class="sections" @submit.prevent="submit">
      <PersonalFields
        :readOnly="readonly"
        :data.sync="userInfo"
        v-model="userInfo"
        :idTypes="idTypes"
        :idType="idType"
        :countryName="countryName"
        :countryPhoneCode="countryPhoneCode"
        @changeId="changeIdAccount"
      />
      <BankInformation
        v-if="isIran"
        :status="status"
        :fullname="userInfo.firstName + ' ' + userInfo.lastName"
        :bankAccounts.sync="userInfo.bankAccounts"
      />
      <ImageUpload
        v-if="
          !['AUTHORIZED', 'INFORMATION_CHANGED'].includes(
            this.state.userInfo.authenticationType
          )
        "
        :readOnly="readonly"
        :data.sync="userInfo"
        :idType="idType"
      />
      <!-- <div>{{userInfo.email}}</div> -->
      <p class="error" style="color: white !important" v-if="disabled">
        *{{ disabled }}
      </p>
      <button
        class="submit-btn"
        :disabled="disabled"
        :class="{ 'disabled-btn': disabled }"
      >
        {{ lang.submitBtn }}
      </button>

      <!-- <button v-if="!readonly" :disabled="disabled" :class="{'confirm-data-btn':true,'disabled-btn':disabled}" type="submit"> ثبت و ارسال اطلاعات </button>
        <button v-if="readonly" :disabled="disabled" :class="{'confirm-data-btn':true,'disabled-btn':disabled}" type="submit"> ویرایش اطلاعات </button> -->
    </form>
    <SelectCountryModal
      v-if="countryModal && userInfo.authenticationType != 'AUTHORIZED'"
      :lang="lang.selectCountry"
      :countryName="countryName"
      :countries="countries"
      @select="countryModal = false"
      @changeCountry="changeCountry($event)"
    />
  </div>
</template>

<script>
const inputLabel = {
  firstName: "نام",
  lastName: "نام خانوادگی",
  email: "ایمیل",
  birthDay: "تاریخ تولد",
  mobileNumber: "شماره موبایل",
  telephone: "شماره ثابت",
  address: "آدرس",
  image: "عکس سلفی",
  city: "شهر",
  state: "محله",
  postalCode: "کد پستی",
  backImage: "عکس پشت کارت",
};
import BankInformation from "./BankInformation";
import PersonalFields from "./PersonalFields";
import ImageUpload from "./ImageUpload";
import SelectCountryModal from "@/components/Panel/Profile/SelectCountryModal";

export default {
  name: "Profile",
  components: {
    ImageUpload,
    BankInformation,
    PersonalFields,
    SelectCountryModal,
  },
  data() {
    return {
      lang: this.$languageDict().profile,
      countries: [],
      countryName: "",
      countryPhoneCode: "",
      countryModal: true,
      idTypes: [],
      idType: "",
      userInfo: {
        authenticationType: "",
        firstName: "",
        lastName: "",
        email: "",
        nationalCode: "",
        birthDay: "",
        mobileNumber: "",
        telephone: "",
        countryName: "",
        city: "",
        state: "",
        postalCode: "",
        address: "",
        image: "",
        backImage: "",
        idFormatType: "",
        profileImage: "",
        bankAccounts: [
          {
            shebaCode: "",
            cardNumber: "",
            bankName: "",
          },
        ],
        identityType: "",
      },
      duplicateBank: "",
      change: 0,
      status: "AUTHORIZED",
    };
  },
  computed: {
    readonly() {
      return [
        "AUTHORIZED",
        "INFORMATION_CHANGED",
        "CONFIRMED_IDENTITY",
      ].includes(this.state.userInfo.authenticationType);
    },
    disabled() {
      const items = [
        "firstName",
        "lastName",
        "email",
        "nationalCode",
        "birthDay",
        "mobileNumber",
        "city",
        "state",
        "postalCode",
        "address",
        "image",
      ];
      if (this.isIran) {
        items.push("telephone");
        items.push("bankAccounts");
      }
      if (!this.userInfo.backImage && this.idType == "ID_CARD") {
        items.push("backImage");
      }
      for (let key in this.userInfo) {
        if (items.includes(key)) {
          if (key === "bankAccounts") {
            if (this.userInfo.bankAccounts.length) {
              for (let data of this.userInfo.bankAccounts) {
                if (
                  !data.shebaCode ||
                  !data.cardNumber ||
                  data.cardNumber.replace(/-/g, "").length < 16 ||
                  data.shebaCode.length != 24
                ) {
                  return this.state.lang === "fa"
                    ? "اطلاعات بانکی اشتباه است"
                    : "bank information is incorrect";
                }
              }
            } else {
              return this.state.lang === "fa"
                ? "حداقل یک حساب بانکی اضافه نمایید"
                : "Please Enter Bank Account";
            }
          } else if (
            key == "telephone" &&
            (!this.userInfo[key] || this.userInfo[key].length !== 11)
          ) {
            return (
              (this.state.lang === "fa" ? inputLabel[key] : key) +
              " " +
              this.lang.correctValue
            );
          } else if (
            key == "mobileNumber" &&
            (!this.userInfo[key] || this.userInfo[key].length !== 10)
          ) {
            return (
              (this.state.lang === "fa" ? inputLabel[key] : key) +
              " " +
              this.lang.correctValue
            );
          } else if (
            key == "nationalCode" &&
            this.isIran &&
            (!this.userInfo[key] || this.userInfo[key].length !== 10)
          ) {
            return this.state.lang === "fa" ? "کدملی اشتباه است" : "wrong id";
          } else if (!this.userInfo[key]) {
            return this.state.lang === "fa"
              ? inputLabel[key] + " اجباریست"
              : key + "is Required";
          }
        }
      }
      return false;
    },
    isIran() {
      return this.countryName == "Iran";
    },
  },
  methods: {
    changeCountry(county) {
      this.countryName = county.countryName;
      this.countryPhoneCode = county.countryPhoneCode;
      this.userInfo.countryName = county.countryName;
    },
    async getIdFormat() {
      this.idTypes = await this.$axios("/users/id-format-type");
      this.idType = this.idTypes[0];
    },
    changeIdAccount(e) {
      this.idType = e;
    },
    async check() {
      this.state.loading = true;

      const res = await this.$axios("/users/account");
      this.userInfo = res.baseDTO;
      const location = this.userInfo.location;
      if (location) {
        this.countryModal = false;
        this.userInfo = { ...this.userInfo, ...location };
        this.userInfo.countryName = location.country.countryName;
        this.userInfo.countryPhoneCode = location.country.countryPhoneCode;
        this.countryName = location.country.countryName;
        this.countryPhoneCode = location.country.countryPhoneCode;
        this.changeCountry(this.userInfo.location.country);
      } else {
        this.userInfo.countryName = "Iran";
        this.countryName = "Iran";
        this.countryPhoneCode = "+98";
        this.userInfo = { ...this.userInfo, city: "", state: "" };
      }

      if (res.baseDTO.idFormatType) {
        this.idType = res.baseDTO.idFormatType;
      }
      this.change++;
    },

    dataURLtoFile(dataurl, filename) {
      let arr = dataurl.split(",");
      console.log(arr);
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, {
        type: mime,
      });
    },
    async submit() {
      if (this.state.loading) return;
      this.state.loading = true;
      this.userInfo.idFormatType = this.idType;
      delete this.userInfo.location;
      if (!this.userInfo.backImage) {
        delete this.userInfo.backImage;
      }
      // if(this.userInfo.image === 'string') delete this.userInfo.image
      // this.data.languageList = this.languages
      let form_data = new FormData();
      let editBody = {};

      for (let key in this.userInfo) {
        if (key == "mobileNumber") {
          form_data.append(
            "mobileNumber",
            this.countryPhoneCode + this.userInfo.mobileNumber
          );
        } else if (key === "image") {
          if (typeof this.userInfo.image !== "string") {
            form_data.append("image", this.userInfo.image);
          } else {
            form_data.append(
              "image",
              this.dataURLtoFile(this.userInfo.image, "image")
            );
          }
        } else if (key === "backImage") {
          if (typeof this.userInfo.backImage !== "string") {
            form_data.append("backImage", this.userInfo.backImage);
          } else {
            form_data.append(
              "backImage",
              this.dataURLtoFile(this.userInfo.backImage, "backImage")
            );
          }
        } else if (
          key === "backImage" &&
          this.userInfo.idFormatType !== "PASSPORT"
        ) {
          if (typeof this.userInfo.backImage !== "string") {
            form_data.append("backImage", this.userInfo.backImage);
          }
        } else if (
          key === "backImage" &&
          this.userInfo.idFormatType === "PASSPORT"
        ) {
          delete this.userInfo.backImage;
        } else if (key !== "bankAccounts") {
          // console.log(key ,  this.userInfo[key])
          form_data.append(key, this.userInfo[key]);
          editBody[key] = this.userInfo[key];
        }
      }

      form_data.append(
        "bankAccountsString",
        JSON.stringify(this.userInfo.bankAccounts)
      );
      editBody.bankAccountsString = JSON.stringify(this.userInfo.bankAccounts);
      // this.userInfo.languages = JSON.stringify(this.userInfo.languages)

      // if (this.bankCheck(this.userInfo.bankAccounts)) {

      try {
        let res = null;
        if (
          ["UNAUTHORIZED", "UNIDENTIFIED", "NOT_COMPLETE"].includes(
            this.userInfo.authenticationType
          )
        ) {
          res = await this.$axios.post("/users/account", form_data);
        } else {
          res = await this.$axios.put("/users/account", editBody);
        }

        this.userInfo.authenticationType = res.baseDTO.authenticationType;
        this.state.userInfo.authenticationType = res.baseDTO.authenticationType;
        this.state.userInfo.email = res.baseDTO.email;
        this.state.userInfo.authorized =
          res.baseDTO.authenticationType === "AUTHORIZED" ||
          res.baseDTO.authenticationType === "INFORMATION_CHANGED_PENDING";
        this.state.userInfo.pending =
          res.baseDTO.authenticationType === "PENDING";
        await this.$error("", this.lang.sendedInfo, "success");

        if (this.isIran) {
          if (res.message.includes("need to be verified")) {
            this.state.loading = true;
            await this.$axios(
              `/finnotech/send-sms-to-customer?email=${this.userInfo.email}`
            );
            this.$router.push("/panel/finotech");
          } else {
            this.$router.push("/");
          }
        } else {
          this.$router.push("/");
        }

        this.$getuserInfo();
      } catch (e) {
        if (
          e.response &&
          e.response.data.message.includes(
            "ShebaCode or CardNumber Is For Another User"
          )
        ) {
          this.$error("", this.lang.repeatShebaOrCard);
          this.duplicateBank = e.response.data.message;
        }
      }
      this.state.loading = false;
    },
    async getCountry() {
      this.countries = await this.$axios("/country");
    },
  },

  async mounted() {
    await this.getIdFormat();
    this.check();
    this.getCountry();
  },
};
</script>

<style scoped>
.submit-btn {
  background: linear-gradient(
    90deg,
    #1a97bf 2.72%,
    #721ac9 28.48%,
    #ab0ae3 62.88%,
    #c102c5 78.84%,
    #bb1396 100%
  );
  border-radius: 8px;
  height: 35px;
  width: 100%;
  max-width: 250px;
  font-size: clamp(15px, 1.5vw, 16px);
  font-weight: bold;
  color: #fcfcfc;
}

.page-title {
  font-size: clamp(24px, 3vw, 36px);
  color: #e0e0e0;
  font-weight: bold;
}

.authentication {
  padding-bottom: 40px;
}

::v-deep .section {
  background: linear-gradient(
    169.98deg,
    rgba(111, 111, 116, 0.34) 0%,
    rgba(67, 70, 141, 0.32) 52.32%,
    rgba(60, 60, 68, 0.32) 92.49%
  );
  border-radius: 12px;
  padding: clamp(14px, 1.8vw, 24px);
  width: 100%;
}

::v-deep .section-title {
  color: #f2f2f2;
  font-weight: bold;
  font-size: clamp(15px, 1.6vw, 18px);
}

::v-deep .section-text {
  margin-top: 8px;
  color: #f2f2f2;
  font-size: clamp(13px, 1.3vw, 14px);
}

.sections {
  display: flex;
  flex-direction: column;
  row-gap: clamp(20px, 2.6vw, 32px);
  align-items: center;
  margin-top: 24px;
}
</style>
